import { useState } from 'react';
import { otpService } from 'ui/services';
import errorMessage from '../constants/errorMessage';
import { useRouter } from 'next/router';
import { setShowPhoneVerificationModal } from '../store/auth/actions';
import { useDispatch } from 'react-redux';

const useOTP = (isLogin = false, sourceAuth = '') => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [nextValidPhoneNumber, setNextValidPhoneNumber] = useState(null);
  const router = useRouter();
  const dispatch = useDispatch();

  const generateOTP = async (
    phoneNumber,
    isCheckOtpLimit = true,
    isHideError = false,
    oldPhoneNumber = '',
    dacUnicode = ''
  ) => {
    try {
      setLoading(true);

      const payload = {
        phoneNumber,
        isCheckOtpLimit,
        uniqueID: phoneNumber,
        isLogin,
        oldPhoneNumber,
        dacUnicode,
      };

      // Generate OTP
      const res = await otpService.generateOTP(payload);
      setError(null);

      // Open otp form modal when success generate otp
      if (res.status === 200) {
        if (res.data.message === 'SMS Success') {
          setError(null);
          sessionStorage.removeItem('error-otp');
          return res.data;
        } else {
          const error: any = new Error(
            res.data?.message || 'Error occured while generating the OTP'
          );
          if (res.data.nextValidAttempt) {
            error.nextValidAttempt = res.data.nextValidAttempt;
          }
          throw error;
        }
      }
    } catch (err) {
      const resDataError = err?.response?.data?.error;
      const message = err?.message;
      if (
        resDataError?.includes('You have reach max otp request') ||
        message.includes('You have reach max otp request')
      ) {
        if (sourceAuth && isHideError) {
          sessionStorage.setItem(
            'error-otp',
            errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
          );
          setError(
            sourceAuth
              ? errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
              : errorMessage.OTP_BLOCKED_ERROR_MESSAGE
          );
          sessionStorage.setItem('phone', phoneNumber);
          dispatch(setShowPhoneVerificationModal(false));
          router.push({
            pathname: '/verifikasi-otp',
            query: {
              source: sourceAuth === 'verify-phone' ? sourceAuth + '-sms' : sourceAuth + '-otp-sms',
            },
          });
        } else {
          setError(
            sourceAuth
              ? errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
              : errorMessage.OTP_BLOCKED_ERROR_MESSAGE
          );
        }
        if (!sourceAuth) {
          try {
            const secondsInString = resDataError.split(':')[1].split(' ')[1];
            const seconds = parseInt(secondsInString);

            const nextValidAttemptInMs = seconds * 1000;
            const nowInMs = new Date().getTime();

            const nextTime = nowInMs + nextValidAttemptInMs;
            const nextTimeDate = new Date(nextTime);
            nextTimeDate.setSeconds(nextTimeDate.getSeconds() + 1);

            setNextValidPhoneNumber(nextTimeDate);
          } catch (error) {
            console.log(error);
          }
        }
        return err;
      }

      if (
        message === 'Invalid phone number format' ||
        resDataError === 'Invalid phone number format'
      ) {
        setError(errorMessage.OTP_GENERATE_INVALID_PHONE_NUMBER_INVALID_ERROR_MESSAGE);
        return;
      }

      if (message?.toLowerCase() === 'sms failed' || resDataError?.toLowerCase() === 'sms failed') {
        setError(errorMessage.OTP_GENERATE_SERVER_ERROR_MESSAGE);
        return;
      }

      if (
        message?.includes('Failed to request new OTP Code, please resend in') ||
        resDataError?.includes('Failed to request new OTP Code, please resend in')
      ) {
        if (!isHideError && !sourceAuth) {
          setError(`${errorMessage.OTP_GENERATE_TIME_ERROR_MESSAGE} ${err.nextValidAttempt} detik`);
        }
        const seconds = parseInt(err.nextValidAttempt);

        // Calculate next valid time
        const nextValidAttemptInMs = seconds * 1000;
        const nowInMs = new Date().getTime();

        const nextTime = nowInMs + nextValidAttemptInMs;
        const nextTimeDate = new Date(nextTime);
        nextTimeDate.setSeconds(nextTimeDate.getSeconds() + 1);

        setNextValidPhoneNumber(nextTimeDate);
        localStorage.setItem('nextValidAttempt', nextTimeDate.toISOString());
        if (sourceAuth && isHideError) {
          sessionStorage.setItem('phone', phoneNumber);
          dispatch(setShowPhoneVerificationModal(false));
          router.push({
            pathname: '/verifikasi-otp',
            query: {
              source: sourceAuth === 'verify-phone' ? sourceAuth + '-sms' : sourceAuth + '-otp-sms',
            },
          });
        }
        return err;
      }

      if (message?.includes('Login with email') || resDataError?.includes('Login with email')) {
        setError('Silakan Login menggunakan email');
        return;
      }

      if (
        message?.toLowerCase() === 'user is disabled' ||
        resDataError?.toLowerCase() === 'user is disabled'
      ) {
        setError('user is disabled');
        return;
      }

      if (
        message?.toLowerCase() === 'customer is not active' ||
        resDataError?.toLowerCase() === 'customer is not active'
      ) {
        setError('customer is not active');
        return;
      }

      if (
        message?.toLowerCase()?.includes('5x failed request') ||
        resDataError?.toLowerCase()?.includes('5x failed request')
      ) {
        setError(errorMessage.OTP_5X_REQUEST_ERROR_MESSAGE);
        return;
      }

      if (
        (message === "Customer doesn't exist" ||
          resDataError === "Customer doesn't exist" ||
          message?.toLowerCase() === 'customer not verified' ||
          resDataError?.toLowerCase() === 'customer not verified') &&
        isLogin
      ) {
        try {
          setLoading(true);

          const payload = {
            phoneNumber,
            isCheckOtpLimit,
            uniqueID: phoneNumber,
            isLogin: false,
          };

          // Generate OTP
          const res = await otpService.generateOTP(payload);
          setError(null);

          // Open otp form modal when success generate otp
          if (res.status === 200) {
            if (res.data.message === 'SMS Success') {
              sessionStorage.removeItem('error-otp');
              setError(null);
              return res.data;
            } else {
              const error: any = new Error(
                res.data?.message || 'Error occured while generating the OTP'
              );
              if (res.data.nextValidAttempt) {
                error.nextValidAttempt = res.data.nextValidAttempt;
              }
              throw error;
            }
          }
        } catch (err) {
          const resDataError = err?.response?.data?.error;
          const message = err?.message;
          if (
            resDataError?.includes('You have reach max otp request') ||
            message.includes('You have reach max otp request')
          ) {
            if (sourceAuth && isHideError) {
              sessionStorage.setItem(
                'error-otp',
                errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
              );
              setError(
                sourceAuth
                  ? errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
                  : errorMessage.OTP_BLOCKED_ERROR_MESSAGE
              );
              sessionStorage.setItem('phone', phoneNumber);
              dispatch(setShowPhoneVerificationModal(false));
              router.push({
                pathname: '/verifikasi-otp',
                query: {
                  source:
                    sourceAuth === 'verify-phone' ? sourceAuth + '-sms' : sourceAuth + '-otp-sms',
                },
              });
            } else {
              setError(
                sourceAuth
                  ? errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
                  : errorMessage.OTP_BLOCKED_ERROR_MESSAGE
              );
            }

            return;
          }

          if (
            message === 'Invalid phone number format' ||
            resDataError === 'Invalid phone number format'
          ) {
            setError(errorMessage.OTP_GENERATE_INVALID_PHONE_NUMBER_INVALID_ERROR_MESSAGE);
            return;
          }

          if (
            message?.includes('Failed to request new OTP Code, please resend in') ||
            resDataError?.includes('Failed to request new OTP Code, please resend in')
          ) {
            if (!isHideError && !isHideError) {
              setError(
                `${errorMessage.OTP_GENERATE_TIME_ERROR_MESSAGE} ${err.nextValidAttempt} detik`
              );
            }
            const seconds = parseInt(err.nextValidAttempt);

            // Calculate next valid time
            const nextValidAttemptInMs = seconds * 1000;
            const nowInMs = new Date().getTime();

            const nextTime = nowInMs + nextValidAttemptInMs;
            const nextTimeDate = new Date(nextTime);
            nextTimeDate.setSeconds(nextTimeDate.getSeconds() + 1);

            setNextValidPhoneNumber(nextTimeDate);
            localStorage.setItem('nextValidAttempt', nextTimeDate.toISOString());
            if (sourceAuth && isHideError) {
              sessionStorage.setItem('phone', phoneNumber);
              dispatch(setShowPhoneVerificationModal(false));
              router.push({
                pathname: '/verifikasi-otp',
                query: {
                  source:
                    sourceAuth === 'verify-phone' ? sourceAuth + '-sms' : sourceAuth + '-otp-sms',
                },
              });
            }
            return;
          }

          if (message?.includes('Login with email') || resDataError?.includes('Login with email')) {
            setError('Silakan Login menggunakan email');
            return;
          }

          if (
            message?.toLowerCase() === 'user is disabled' ||
            resDataError?.toLowerCase() === 'user is disabled'
          ) {
            setError('user is disabled');
            return;
          }

          if (
            message?.toLowerCase() === 'customer is not active' ||
            resDataError?.toLowerCase() === 'customer is not active'
          ) {
            setError('customer is not active');
            return;
          }

          setError(errorMessage.OTP_GENERATE_SERVER_ERROR_MESSAGE);
        } finally {
          setLoading(false);
        }
      }

      if (err?.response?.status === 429) {
        return setError(errorMessage.OTP_GENERATE_RATE_LIMIT_ERROR_MESSAGE);
      }

      setError(errorMessage.OTP_GENERATE_SERVER_ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  };

  const generateWAOTP = async (
    phoneNumber,
    isCheckOtpLimit = true,
    isHideError = false,
    oldPhoneNumber = undefined,
    dacUnicode = ''
  ) => {
    try {
      setLoading(true);
      setError(null);

      const payload = {
        phoneNumber,
        isCheckOtpLimit,
        uniqueID: phoneNumber,
        isLogin,
        oldPhoneNumber,
        dacUnicode,
      };

      // Generate OTP
      const res = await otpService.generateWAOTP(payload);
      setError(null);

      // Open otp form modal when success generate otp
      if (res.status === 200) {
        if (res.data.message === 'success') {
          setError(null);
          sessionStorage.removeItem('error-otp');
          return res.data;
        } else {
          const error: any = new Error(
            res.data?.message || 'Error occured while generating the OTP'
          );
          if (res.data.nextValidAttempt) {
            error.nextValidAttempt = res.data.nextValidAttempt;
          }
          throw error;
        }
      }
    } catch (err) {
      const resDataError = err?.response?.data?.error;
      const message = err?.message;
      if (
        resDataError?.includes('You have reach max otp request') ||
        message?.includes('You have reach max otp request')
      ) {
        if (sourceAuth && isHideError) {
          sessionStorage.setItem(
            'error-otp',
            errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
          );
          setError(
            sourceAuth
              ? errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
              : errorMessage.OTP_BLOCKED_ERROR_MESSAGE
          );
          sessionStorage.setItem('phone', phoneNumber);
          dispatch(setShowPhoneVerificationModal(false));
          router.push({
            pathname: '/verifikasi-otp',
            query: { source: sourceAuth },
          });
        } else {
          setError(
            sourceAuth
              ? errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
              : errorMessage.OTP_BLOCKED_ERROR_MESSAGE
          );
        }
        if (!sourceAuth) {
          try {
            const secondsInString = resDataError.split(':')[1].split(' ')[1];
            const seconds = parseInt(secondsInString);

            const nextValidAttemptInMs = seconds * 1000;
            const nowInMs = new Date().getTime();

            const nextTime = nowInMs + nextValidAttemptInMs;
            const nextTimeDate = new Date(nextTime);
            nextTimeDate.setSeconds(nextTimeDate.getSeconds() + 1);

            setNextValidPhoneNumber(nextTimeDate);
          } catch (error) {
            console.error(error);
          }
        }

        return err;
      }

      if (
        message === 'Invalid phone number format' ||
        resDataError === 'Invalid phone number format'
      ) {
        setError(errorMessage.OTP_GENERATE_INVALID_PHONE_NUMBER_INVALID_ERROR_MESSAGE);
        return;
      }

      if (
        message?.includes('Failed to request new OTP Code, please resend in') ||
        resDataError?.includes('Failed to request new OTP Code, please resend in')
      ) {
        const errMsg = err?.message;
        const secondsInString = errMsg
          .replace('Failed to request new OTP Code, please resend in ', '')
          .split(' ')[0];
        const seconds = parseInt(secondsInString);

        // Calculate next valid time
        const nextValidAttemptInMs = seconds * 1000;
        const nowInMs = new Date().getTime();

        const nextTime = nowInMs + nextValidAttemptInMs;
        const nextTimeDate = new Date(nextTime);
        nextTimeDate.setSeconds(nextTimeDate.getSeconds() + 1);

        setNextValidPhoneNumber(nextTimeDate);
        localStorage.setItem('nextValidAttempt', nextTimeDate.toISOString());
        if (!isHideError && !sourceAuth) {
          setError(`${errorMessage.OTP_GENERATE_TIME_ERROR_MESSAGE} ${secondsInString} detik`);
        }
        if (sourceAuth && isHideError) {
          sessionStorage.setItem('phone', phoneNumber);

          dispatch(setShowPhoneVerificationModal(false));
          router.push({
            pathname: '/verifikasi-otp',
            query: { source: sourceAuth },
          });
        }
        return err;
      }

      if (message?.includes('Login with email') || resDataError?.includes('Login with email')) {
        setError('Silakan Login menggunakan email');
        return;
      }

      if (
        message?.toLowerCase() === 'user is disabled' ||
        resDataError?.toLowerCase() === 'user is disabled'
      ) {
        setError('user is disabled');
        return;
      }

      if (
        message?.toLowerCase() === 'customer is not active' ||
        resDataError?.toLowerCase() === 'customer is not active'
      ) {
        setError('customer is not active');
        return;
      }

      if (
        message?.toLowerCase()?.includes('5x failed request') ||
        resDataError?.toLowerCase()?.includes('5x failed request')
      ) {
        setError(errorMessage.OTP_5X_REQUEST_ERROR_MESSAGE);
        return;
      }

      if (
        (message === "Customer doesn't exist" ||
          resDataError === "Customer doesn't exist" ||
          message.toLowerCase() === 'customer not verified' ||
          resDataError?.toLowerCase() === 'customer not verified') &&
        isLogin
      ) {
        try {
          setLoading(true);
          setError(null);

          const payload = {
            phoneNumber,
            isCheckOtpLimit,
            uniqueID: phoneNumber,
            isLogin: false,
          };

          // Generate OTP
          const res = await otpService.generateWAOTP(payload);
          setError(null);

          // Open otp form modal when success generate otp
          if (res.status === 200) {
            if (res.data.message === 'success') {
              sessionStorage.removeItem('error-otp');
              setError(null);
              return res.data;
            } else {
              const error: any = new Error(
                res.data?.message || 'Error occured while generating the OTP'
              );
              if (res.data.nextValidAttempt) {
                error.nextValidAttempt = res.data.nextValidAttempt;
              }
              throw error;
            }
          }
        } catch (err) {
          const resDataError = err?.response?.data?.error;
          const message = err?.message;
          if (
            resDataError?.includes('You have reach max otp request') ||
            message?.includes('You have reach max otp request')
          ) {
            if (sourceAuth && isHideError) {
              sessionStorage.setItem(
                'error-otp',
                errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
              );
              setError(
                sourceAuth
                  ? errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
                  : errorMessage.OTP_BLOCKED_ERROR_MESSAGE
              );
              sessionStorage.setItem('phone', phoneNumber);

              dispatch(setShowPhoneVerificationModal(false));
              router.push({
                pathname: '/verifikasi-otp',
                query: { source: sourceAuth },
              });
            } else {
              setError(
                sourceAuth
                  ? errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
                  : errorMessage.OTP_BLOCKED_ERROR_MESSAGE
              );
            }

            return;
          }

          if (
            message === 'Invalid phone number format' ||
            resDataError === 'Invalid phone number format'
          ) {
            setError(errorMessage.OTP_GENERATE_INVALID_PHONE_NUMBER_INVALID_ERROR_MESSAGE);
            return;
          }

          if (
            message?.includes('Failed to request new OTP Code, please resend in') ||
            resDataError?.includes('Failed to request new OTP Code, please resend in')
          ) {
            const errMsg = err?.message;
            const secondsInString = errMsg
              .replace('Failed to request new OTP Code, please resend in ', '')
              .split(' ')[0];
            const seconds = parseInt(secondsInString);

            // Calculate next valid time
            const nextValidAttemptInMs = seconds * 1000;
            const nowInMs = new Date().getTime();

            const nextTime = nowInMs + nextValidAttemptInMs;
            const nextTimeDate = new Date(nextTime);
            nextTimeDate.setSeconds(nextTimeDate.getSeconds() + 1);

            setNextValidPhoneNumber(nextTimeDate);
            localStorage.setItem('nextValidAttempt', nextTimeDate.toISOString());
            if (!isHideError && !sourceAuth) {
              setError(`${errorMessage.OTP_GENERATE_TIME_ERROR_MESSAGE} ${secondsInString} detik`);
            }
            if (sourceAuth && isHideError) {
              sessionStorage.setItem('phone', phoneNumber);
              dispatch(setShowPhoneVerificationModal(false));
              router.push({
                pathname: '/verifikasi-otp',
                query: { source: sourceAuth },
              });
            }
            return;
          }

          if (message?.includes('Login with email') || resDataError?.includes('Login with email')) {
            setError('Silakan Login menggunakan email');
            return;
          }

          if (
            message?.toLowerCase() === 'user is disabled' ||
            resDataError?.toLowerCase() === 'user is disabled'
          ) {
            setError('user is disabled');
            return;
          }

          if (
            message?.toLowerCase() === 'customer is not active' ||
            resDataError?.toLowerCase() === 'customer is not active'
          ) {
            setError('customer is not active');
            return;
          }

          setError(errorMessage.OTP_GENERATE_SERVER_ERROR_MESSAGE);
        } finally {
          setLoading(false);
        }
      }

      if (err?.response?.status === 429) {
        return setError(errorMessage.OTP_GENERATE_RATE_LIMIT_ERROR_MESSAGE);
      }

      setError(errorMessage.OTP_GENERATE_SERVER_ERROR_MESSAGE);
      return err;
    } finally {
      setLoading(false);
    }
  };

  const validateOTP = async (
    phoneNumber: any,
    otpValue: string,
    validateType: 'LOGIN' | 'REGISTER' | 'REGISTER_DAC' | 'CHANGE_PHONE_DAC' = null
  ) => {
    try {
      setLoading(true);
      const payload = {
        phoneNumber,
        otp: otpValue,
        uniqueID: phoneNumber,
        ...(validateType && { validateType }),
      };

      // Validate OTP
      const res = await otpService.validateOTP(payload);
      // Push to success page if otp is valid
      if (res?.status === 200) {
        if (res?.data?.message?.toLowerCase() === 'valid') {
          sessionStorage.removeItem('error-otp');
          setError(null);
          return res.data;
        } else {
          const error = new Error(res.data?.message || 'Error occured while validating the OTP');
          throw error;
        }
      }
    } catch (err) {
      if (err?.message.includes('You have reach max otp request')) {
        setError(
          sourceAuth
            ? errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
            : errorMessage.OTP_BLOCKED_ERROR_MESSAGE
        );
        return;
      }

      if (err?.message === 'Not Valid' || err?.message === 'invalid') {
        setError(errorMessage.OTP_INVALID_ERROR_MESSAGE_LOGIN_REGISTER);
        return;
      }

      setError(err?.response?.data?.error || errorMessage.OTP_SERVER_ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  };

  const validateOTP2 = async ({
    phoneNumber,
    otpValue,
    oldPhoneNo,
    validateType = null,
  }: {
    phoneNumber: string;
    otpValue: string;
    oldPhoneNo?: string;
    validateType?: 'LOGIN' | 'REGISTER' | 'REGISTER_DAC' | 'CHANGE_PHONE_DAC';
  }) => {
    try {
      setLoading(true);
      const payload = {
        phoneNumber,
        uniqueID: phoneNumber,
        otpValue,
        isCheckOtpLimit: true,
        ...(oldPhoneNo && { oldPhoneNo }),
        ...(validateType && { validateType }),
      };

      // Validate OTP
      const res = await otpService.validateOTP(payload);
      // Push to success page if otp is valid
      if (res?.status === 200) {
        if (res?.data?.message?.toLowerCase() === 'valid') {
          sessionStorage.removeItem('error-otp');
          setError(null);
          return res.data;
        } else {
          const error = new Error(res.data?.message || 'Error occured while validating the OTP');
          throw error;
        }
      } else {
        const error = new Error(res.data?.message || 'Error occured while validating the OTP');
        throw error;
      }
    } catch (err) {
      const message = err?.message;
      if (err?.message.includes('You have reach max otp request')) {
        setError(
          sourceAuth
            ? errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
            : errorMessage.OTP_BLOCKED_ERROR_MESSAGE
        );
        if (!sourceAuth) {
          try {
            const secondsInString = message.split(':')[1].split(' ')[1];
            const seconds = parseInt(secondsInString);

            const nextValidAttemptInMs = seconds * 1000;
            const nowInMs = new Date().getTime();

            const nextTime = nowInMs + nextValidAttemptInMs;
            const nextTimeDate = new Date(nextTime);
            nextTimeDate.setSeconds(nextTimeDate.getSeconds() + 1);

            setNextValidPhoneNumber(nextTimeDate);
          } catch (error) {
            console.log(error);
          }
        }
        return;
      }

      if (err?.message === 'Not Valid' || err?.message === 'invalid') {
        setError(errorMessage.OTP_INVALID_ERROR_MESSAGE_LOGIN_REGISTER);
        return;
      }

      if (err?.message === 'Expired') {
        setError(errorMessage.OTP_EXPIRED_ERROR_MESSAGE);
        return;
      }

      setError(err?.response?.data?.error || errorMessage.OTP_SERVER_ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  };

  const validateWAOTP = async (
    phoneNumber,
    otpValue,
    oldPhoneNo = null,
    validateType: 'LOGIN' | 'REGISTER' | 'REGISTER_DAC' | 'CHANGE_PHONE_DAC' = null
  ) => {
    try {
      setLoading(true);
      const payload = {
        phoneNumber,
        otp: otpValue,
        uniqueID: phoneNumber,
        ...(oldPhoneNo && { oldPhoneNo }),
        ...(validateType && { validateType }),
      };

      // Validate OTP
      const res = await otpService.validateWAOTP(payload);

      // Push to success page if otp is valid
      if (res?.status === 200) {
        if (res?.data?.message?.toLowerCase() === 'valid') {
          sessionStorage.removeItem('error-otp');
          setError(null);
          return res.data;
        } else {
          const error = new Error(res.data?.message || 'Error occured while validating the OTP');
          throw error;
        }
      } else {
        const error = new Error(res.data?.message || 'Error occured while validating the OTP');
        throw error;
      }
    } catch (err) {
      if (err?.message.includes('You have reach max otp request')) {
        setError(
          sourceAuth
            ? errorMessage.OTP_BLOCKED_ERROR_MESSAGE_LOGIN_REGISTER
            : errorMessage.OTP_BLOCKED_ERROR_MESSAGE
        );
        return;
      }

      if (err?.message === 'Not Valid' || err?.message === 'invalid') {
        setError(errorMessage.OTP_INVALID_ERROR_MESSAGE_LOGIN_REGISTER);
        return;
      }

      if (err?.message === 'Expired') {
        setError(errorMessage.OTP_EXPIRED_ERROR_MESSAGE);
        return;
      }

      setError(err?.response?.data?.error || errorMessage.OTP_SERVER_ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  };

  const resetError = () => {
    setError(null);
  };

  return {
    error,
    loading,
    nextValidPhoneNumber,
    generateWAOTP,
    generateOTP,
    validateOTP,
    validateOTP2,
    validateWAOTP,
    resetError,
    setError,
  };
};

export default useOTP;
